import { stripStatus } from './strip-status';
import { parseCentreOrLinkedStoreHours } from './parse-centre-or-linked-store-hours';
export function parseCentreOpeningHours(tradingHours, centreTimeZone, centreFeatures) {
  return stripStatus(parseCentreOrLinkedStoreHours(tradingHours, centreTimeZone, centreFeatures));
}